<template>
    <div class="store" >
        <div class="content" v-if="contentShow">
            <TopTips :appConfig="appConfig"/>
            <!-- 商城卡片列表 -->
            <el-card class="box-card">
                
                <el-tabs class="content_top" v-model="activeIdx" @tab-click="changeTab"  v-loading="loadTabList" >
                    <el-tab-pane class="tab" :class="appConfig.appId && appConfig.appId == '1018' ? 'otherTab' : ''" v-for="item of goodsList" :key="item.typeKeyIdx" :name="item.typeKeyIdx + ''">
                        <span slot="label">
                            <p slot="reference">{{item.typeName}}</p>
                        </span>
                        <div v-if="showCard" class="content_center" :class="{'scroll_bar_none': !isScroll}" >
                               <RecycleScroller class="scroller-container" :items="currentTabGoods" :item-size="350" key-field="rowId" :buffer="1" v-slot="{ item }" @scroll-end="handleResize">
                                    <div class="card-grid">
                                        <el-card class="card" v-for="(card, key) of item.list" :key="key">
                                            <div @click="detialShow(card)">
                                                <div class="item_icon" :style="{'backgroundImage': 'url(' + card.goodsIcon + ')'}"></div>
                                                <div class="item_name" :class="{'min_font': card.iapName.length > 0}">{{card.iapName}}</div>
                                                <div class="item_limit" v-if="card.limitNum">{{$t('left')}} {{card.limitNum}}/{{card.boughtNum + card.limitNum}}</div>
                                                <div class="item_limit_time" v-if="card.endTs > 0">{{$t('leftTime')}} {{formatDate((card.endTs + card.timeZone.split(':')[0].substr(3, 5) * 3600 + new Date().getTimezoneOffset() * 60) * 1000)}}</div>
                                                <div class="item_limit_time none" v-if="card.endTs <= 0"></div>
                                                <el-button v-if="!isLogin" class="item_point" type="danger" size="small" @click.stop="showDialog">{{$t('buy')}}</el-button>
                                                <el-button v-if="isLogin" class="item_point" type="danger" size="small" @click.stop="plusNum(card, true)" :disabled="card.limitNum !== 0 && (card.amount == card.limitNum)">{{unit+ '  ' + formatNumber(pcgJsonData[card.price])}}</el-button>
                                            </div>
                                        </el-card>
                                    </div>
                                </RecycleScroller>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
            <el-badge v-if="!buyListShow && listCount > 0" class="buy_car" :value="listCount">
                <i class="el-icon-shopping-cart-2" @click="showBuyDialog"></i>
                <div></div>
                <i class="el-icon-shopping-cart-2 point_cart" :class="isAnimate ? 'cartSlideOut' : ''" @animationend="isAnimate = false"></i>
            </el-badge>
        </div>
        <!-- 购物列表 -->
        <el-dialog v-if="isLogin && allGearData && allGearData.currencyList && currency" class="content_right" :visible.sync="buyDialogShow" width="60%">
           
            <div class="left_detial">
                <p style="text-align: left;text-indent: 20px;">
                    <span style="margin-right: 40px">{{storage.roleName}}</span>
                    <span v-if="storage.serverName">{{storage.serverName}}</span>
                </p>
            </div>
            <!-- 购买商品列表 -->
            <div class="buy_list_box">
                <div class="buy_list" v-for="(item, key) of buyList" :key="key">
                    <div class="list_icon" :style="{'backgroundImage': 'url(' + item.goodsIcon + ')'}"></div>
                    <div style="justify-content: space-around;display: flex;align-items: stretch;flex-direction: column;height: 100%;">
                        <div class="list_name">{{item.iapName}}</div>
                        <div class="list_limit">
                            <span v-if="item.limitNum">{{$t('left')}} {{item.limitNum}}/{{item.boughtNum + item.limitNum}}</span>
                            <span v-if="item.endTs > 0">{{$t('leftTime')}} {{formatDate((item.endTs + item.timeZone.split(':')[0].substr(3, 5) * 3600 + new Date().getTimezoneOffset() * 60) * 1000)}}</span>
                            <div style="clear:both"></div>
                        </div>
                        <div class="item_count">
                            <span class="list_point">{{ (payment&&payment.payChannel == "point"
                      ? $t("rebatePoint"):unit) + '  ' + formatNumber((payment&&payment.payChannel == "point"?item.scaledPoints:pcgJsonData[item.price] ))}}</span>
                            <div class="shop-cart-content">
                                <!-- <span class="cost" v-if="item.goodsType !== 2" @click="costNum(item)">-</span> -->
                                <el-input-number 
                                    :class="{'disable-btn': item.limitNum !== 0 && (item.amount == item.limitNum)}" 
                                    size="mini" 
                                    v-model="item.amount"  
                                    :min="0" 
                                    :precision="0" 
                                    :max="item.limitNum !== 0?item.limitNum:1000000"
                                    :step="1"
                                    @change="changeNum(item)"
                                    >
                                </el-input-number>
                                <!-- <span class="plus" v-if="item.goodsType !== 2" :class="(item.limitNum !== 0 && (item.amount == item.limitNum))? 'plus_disable' : ''" @click="plusNum(item)">+</span> -->
                            </div>
                        </div>
                    </div>
                    <div style="clear:both"></div>
                </div>
            </div>
            <!-- 支付方式列表 -->
            <div class="pay_box">
              <div class="channel_title">{{$t('payTypeSelect')}}</div>
              <div class="channel_box" v-if="pcPmLoading">
                  <div class="channel" v-for="(item, key) of pcPmData.paymentList" :key="key" :class="{'channel_hover': item.payModeId == activePayTab}" @click="changePayment(item)">
                      <div>{{item.payModeName}}</div>
                      <div>({{(item.payChannel == "point"
                    ? $t("rebatePoint"):unit) + '  ' +  formatNumber(item.payMin)}}-{{unit + '  ' +  formatNumber(item.payMax)}})</div>
                  </div>
              </div>
            </div>
            <!-- 合计与确认 -->
            <div class="submit_box">
                <!-- 韩国差异化处理 -->
                <div class="total_count">{{$t('totalLabel')}} {{(payment&&payment.payChannel == "point"
                    ? $t("rebatePoint"):unit)}}{{formatNumber(((payment&&payment.payChannel == "point"?(pointTotalCount/100):(totalCount/100)).toFixed(appId=='1019'?0:2) + ''))}}
                    <el-button class="submit" @click="toPay" :disabled="!activePayTab">{{$t('orderSubmit')}}</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 详情页面  点击卡片触发 -->
        <GoodsDetail @plusNum="plusNum" @closeDialog="detailDialogShow=false" :pcgJsonData="pcgJsonData" v-if="detailDialogShow" :detailData="detailData" :unit="unit" :isLogin="isLogin"/>
    </div>
</template>
 
<script>
import {mapActions, mapGetters} from 'vuex';
import eventBus from '../utils/eventBus'
import moment from 'moment'
import GoodsDetail from '../components/store/GoodsDetail'
import TopTips from '../components/store/TopTips'

export default {
    name: 'store',
    props: [
        'showDialog',
        'logoutAll'
    ],
    components: {
        GoodsDetail,
        TopTips
    },
    data(){
        return {
            loadTabList:false,
            buyList: [],
            goodsList: [],
            buyListShow: true,
            buyDialogShow: false,
            storage: {},
            activeIdx: '',
            contentShow: false,
            totalCount: 0,
            listCount: 0,
            popShow: false,
            dialogShow: false,
            orderList: [],
            tabTypeName: '',
            pageNumber: 1,
            totalPage: 0,
            orderLoad: false,
            noMore: false,
            isScroll: false,
            currency: '',
            isLogin: false,
            mustInteger: 0,
            activePayTab: '',
            detailData: {},
            detailDialogShow: false,
            isAnimate: false,
            appConfig: {},
            pcgJsonData: {},
            appId:'',
            payment:{},
            pointTotalCount: 0,
            maxBuyCount: 500,//最大购买上限，原来是1000  limit1kGoods改成buyMaxCountTips  翻译
            maxTipsCount: 300,//最大提示数量
        }
    },
    methods:{
        ...mapActions(['getPCCountry', 'serverIapList', 'getPCGear', 'getThirdPayOrderList', 'getAllGear', 'getWebUnLoadGoods', 'getPCPayM', 'createThirdPayOrder']),
        handleResize(){
            console.log('resize--');
            
        },
        //千分位分隔符
        formatNumber(num) {
            return (num+'').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        detialShow(data){
            console.log(data)
            this.detailData = data
            this.detailDialogShow = true
        },
        changePayment(item){
      
            this.activePayTab = item.payModeId
            this.currency = item.currency
            this.countryId = item.countryId
            this.mustInteger = item.mustInteger
            this.getPCGear({
                targetCurrency: item.currency,
                countryId: window.localStorage.getItem('countryId'),
                appId: CONFIG.appId,
                accessToken: this.storage.accessToken
            })
            this.payment = item
        },
        showBuyDialog(){
            this.buyDialogShow = true
            this.getPCPayM({
                appId: CONFIG.appId,
                language: window.localStorage.getItem('language'),
                accessToken: this.storage.accessToken,
                countryId: window.localStorage.getItem('countryId'),
                currency: this.currency,
                goodsLists: this.buyList,
                totalMoney: ((this.totalCount/100).toFixed(2))
            })
        },
        orderScroll(){
            if(this.totalPage > this.pageNumber){
                this.pageNumber += 1
                console.log(this.pageNumber)
                this.orderLoad = true
                this.getThirdPayOrderList({
                    uid: this.storage.uid,
                    accessToken: this.storage.accessToken,
                    pageNumber: this.pageNumber,
                    language: window.localStorage.getItem('language'),
                    appId: CONFIG.appId,
                    serverId: this.storage.serverId,
                    roleId: this.storage.roleId,
                    areaId: this.storage.areaId,
                })
            } else if(this.totalPage == this.pageNumber){
                this.noMore = true
            }
        },
        clearHandle(){
            this.$confirm(this.$t('clearSure'), this.$t('sureAgain'), {
                cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('sure'),
                center: true
            })
            .then(() => {
                this.goodsList = this.goodsList.map(v => {
                    if(v.goodsInfo.length > 0){
                        v.goodsInfo = v.goodsInfo.map(goodsV => {
                            goodsV.amount = 0
                            return goodsV
                        })
                    }
                    return v
                })
                this.buyList = []
                this.totalCount = 0
                this.pointTotalCount=0
                this.listCount = 0
                this.buyListShow = false
                this.buyList.map(v => {
                    this.totalCount += Number(this.curGearInfo[v.price] * 100) * v.amount
                    this.pointTotalCount += Number(v.scaledPoints* 100) * v.amount
                    this.listCount += v.amount
                })
                this.storage.buyList = JSON.stringify(this.buyList)
                window.localStorage.setItem('storage', JSON.stringify(this.storage))

            })
        },
        dialogCtrl(tag){
            if(tag == 'record'){
                this.orderLoad = true
                this.popShow = false
                this.orderList = []
                this.pageNumber = 1
                this.getThirdPayOrderList({
                    uid: this.storage.uid,
                    accessToken: this.storage.accessToken,
                    pageNumber: 1,
                    language: window.localStorage.getItem('language'),
                    appId: CONFIG.appId,
                    serverId: this.storage.serverId,
                    roleId: this.storage.roleId,
                    areaId: this.storage.areaId,
                })
            }
        },
        popCtrl(){
            if(this.popShow){
                this.popShow = false
            } else {
                this.popShow = true
            }
        },
        pageClose(){
            window.vuplex && window.vuplex.postMessage({type: 'close', message: '关闭网页'})
        },
         // 商品总价值是否小于礼金总数量
        canPayByPoint() {
            let count = 0;
            this.buyList.forEach((item) => {
                count += item.scaledPoints * item.amount * 100;
            });
            return (this.pointData.userPointData || 0) * 100 >= count;
        },
        toPay() {
              if (this.listCount > this.maxTipsCount) {
                this.$confirm(this.$t("buyCountTips"), this.$t("sureAgain"), {
                    confirmButtonText: this.$t("sure"),
                    cancelButtonText: this.$t("cancel"),
                    center: true, // 重要，设置为true才会把右上角X和取消区分开来
                })
                .then(() => {
                    this.submitPay()
                })
                .catch(() => {
                });
                return
            } else {
                this.submitPay()
            }

        },
        submitPay(){
            if(!this.payment.currency){
                return false
            }
            let item = this.payment
            if(this.showPoint&& item.payChannel == "point"){
                if (!this.canPayByPoint()) {
                    this.$message.error(this.$t("error4003"));
                    return;
                }
                if (
                this.pwdFlag &&
                !this.pwdFlag.isPasswordSet &&
                !this.pointInit.isInitialPointPay // 未初始化礼金支付
                ) {
                    this.$confirm(this.$t("toSetPayPwd"), this.$t("payTits"), {
                        confirmButtonText: this.$t("setPayPwd"),
                        cancelButtonText: this.$t("stillPay"),
                        customClass: 'point-pay-dialog',
                        distinguishCancelAndClose: true, // 重要，设置为true才会把右上角X和取消区分开来
                    })
                    .then(() => {
                    // this.$refs.pointPayDialog.showDialog("setPwd");
                    eventBus.$emit('showPwdOrEmailDialog','setPwd')
                    })
                    .catch((action) => {
                    if (action === "close") {
                        // 点击关闭按钮的操作
                    } else if (action === "cancel") {
                        // 点击取消按钮的操作
                        this.payHandle();
                    }
                    });
                    // 没有密码
                } else if (this.pwdFlag && !this.pwdFlag.isPasswordSet) {
                    this.payHandle();
                } else {
                    //密码支付
                    eventBus.$emit('showPwdOrEmailDialog',)
                }
            } else {
                this.loading = true;
                this.payHandle();
            }
        },

        payHandle(val){
            if(!val||val.length==6){
                let item = this.payment
                let payExtInfo = {
                    ...JSON.parse(item.payExtInfo),
                    country: item.country,
                    language: window.localStorage.getItem('language'),
                    paymentDetail: JSON.parse(item.payExtInfo)
                }
                this.createThirdPayOrder({
                    payChannel: item.payChannel,
                    appId: CONFIG.appId,
                    goodsLists: this.buyList,
                    payExtInfo: payExtInfo,
                    returnUrl: window.location.origin + '/finish',
                    // returnUrl: 'https://www.baidu.com',
                    countryId: window.localStorage.getItem('countryId'),
                    payModeId: item.payModeId,
                    payCurrency: item.currency,
                    orderOrigin: 'pc',
                    cpCurrency: this.buyList[0].currency,
                    accessToken: this.storage.accessToken,
                    payPassword:val? this.$md5(val):undefined
                })
            }
        },
        changeTab(data){
            this.tabTypeName = this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].typeName
            if(this.buyListShow == true){
                if(this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].goodsInfo.length > 4){
                    this.isScroll = true
                } else {
                    this.isScroll = false
                }
            } else {
                if(this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].goodsInfo.length > 6){
                    this.isScroll = true
                } else {
                    this.isScroll = false
                }
            }
            console.log(this.isScroll)
        },
        changeNum(data){
      
         
            this.$nextTick(() => {
                 // 获取总数
                let total=this.buyList.reduce((pre,cur) => {
                    return pre + cur.amount
                }, 0)
                if (total >= this.maxBuyCount) {
                    this.$message.error(this.$t("buyMaxCountTips"));
                    // 其他产品数量统计
                    const otherTotal=this.buyList.filter(v => v.iapId != data.iapId).reduce((pre,cur) => {
                        return pre + cur.amount
                    }, 0)
                    data.amount = this.maxBuyCount - otherTotal
                    // return false;
                }
                this.pointTotalCount = 0
                this.totalCount = 0
                let oldListCount = this.listCount
                this.listCount = 0
                this.buyList.map((v) => {
                    if(v.iapId == data.iapId){
                        v.amount = data.amount
                    }
                })
                this.buyList = this.buyList.filter( i => {
                    return i.amount>0 })||[]
                this.goodsList = this.iapInfo.map(v => {
                    if(v.goodsInfo.length > 0){
                        v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
                        v.goodsInfo = v.goodsInfo.map(goodsV => {
                            goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
                            return goodsV
                        })
                    }
                    return v
                })
                this.goodsList = this.goodsList.filter(i => i.goodsInfo.length > 0)
            
                this.buyList.map(v => {
                    this.totalCount += Number(this.pcgJsonData[v.price] * 100) * v.amount
                    this.pointTotalCount += Number(v.scaledPoints* 100) * v.amount
                    this.listCount += v.amount
                
                })
                this.buyListShow = this.buyList.length ==0
                this.buyDialogShow = this.buyList.length > 0
                this.isAnimate = oldListCount<this.listCount  
                this.storage.buyList = JSON.stringify(this.buyList)
                window.localStorage.setItem('storage', JSON.stringify(this.storage))
            })
        },
        costNum(data){
            if(data.amount == 0){
                return false
            }
            data.amount -= 1
            this.pointTotalCount = 0
            this.totalCount = 0
            this.listCount = 0
            this.buyList.map((v, k) => {
                if(v.iapId == data.iapId){
                    if(data.amount > 0){
                        v.amount = data.amount
                    } else {
                        this.buyList.splice(k, 1)
                        // window.localStorage.setItem('storage', )
                    }
                }
            })
            this.goodsList = this.iapInfo.map(v => {
                if(v.goodsInfo.length > 0){
                    v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
                    v.goodsInfo = v.goodsInfo.map(goodsV => {
                        goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
                        return goodsV
                    })
                }
                return v
            })
            this.goodsList = this.goodsList.filter(i => i.goodsInfo.length > 0)
            this.buyList.map(v => {
                this.totalCount += Number(this.pcgJsonData[v.price] * 100) * v.amount
                this.pointTotalCount += Number(v.scaledPoints* 100) * v.amount
                this.listCount += v.amount
            })
            if(this.listCount == 0){
                this.buyListShow = false
                this.buyDialogShow = false
            }
            this.storage.buyList = JSON.stringify(this.buyList)
            window.localStorage.setItem('storage', JSON.stringify(this.storage))
        },
       
        plusNum(data, isAnimate){
            if(data.limitNum !== 0 && (data.amount == data.limitNum)){
                return false
            }
            if (this.listCount >= this.maxBuyCount) {
                this.$message.error(this.$t("buyMaxCountTips"));
                return false;
            }
            data.amount += 1
            this.totalCount = 0
            this.pointTotalCount = 0
            this.listCount = 0
            let count = 0
            let pointCount = 0
            if(this.buyList.length == 0 || this.buyList.filter(v => v.iapId == data.iapId).length == 0){
                this.buyList.push(data)
                this.buyList.map(v => {
                    count += Number(this.pcgJsonData[v.price] * 100) * v.amount
                    this.listCount += v.amount
                    pointCount+= Number(v.scaledPoints* 100) * v.amount
                })
                this.totalCount = count
                this.pointTotalCount = pointCount
            } else {
                this.buyList.map(v => {
                    if(v.iapId == data.iapId){
                        if(data.amount > 0){
                            v.amount = data.amount
                        }
                        count += Number(this.pcgJsonData[v.price] * 100) * data.amount
                        pointCount+= Number(v.scaledPoints* 100) * v.amount
                        this.listCount += data.amount
                    } else {
                        count += Number(this.pcgJsonData[v.price] * 100) * v.amount
                        pointCount+= Number(v.scaledPoints* 100) * v.amount
                        this.listCount += v.amount
                    }
                })
                this.totalCount = count
                this.pointTotalCount = pointCount
            }
            console.log(this.buyList)
            this.buyList = this.buyList.filter( i => i.amount !== 0)
            this.goodsList = this.iapInfo.map(v => {
                if(v.goodsInfo.length > 0){
                    v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
                    v.goodsInfo = v.goodsInfo.map(goodsV => {
                        goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
                        return goodsV
                    })
                }
                return v
            })
            this.goodsList = this.goodsList.filter(i => i.goodsInfo.length > 0)
            if(this.buyList.length == 0){
                this.buyListShow = true
            } else {
                this.buyListShow = false
            }
            this.isAnimate = true
            this.storage.buyList = JSON.stringify(this.buyList)
            window.localStorage.setItem('storage', JSON.stringify(this.storage))
        },
        logout(){
            this.isLogin = false
            this.getWebUnLoadGoods({
                appId: CONFIG.appId,
                language: window.localStorage.getItem('language')
            })
        }
    },
    computed:{
        ...mapGetters([ 'pointData', "pointInit",'pwdFlag',"uwLoading", "pointSwitch",'status', 'pccData', 'pccLoading', 'iapInfo', 'iapLoading', 'pcgData', 'pcgLoading', 'orderLoading', 'orderInfo', 'allGearData', 'allGearLoading', 'wUnloadData', 'wUnloadLoading','pcPmData', 'pcPmLoading', 'orderStatus', 'orderData']),
        formatDate: (val) => {
            return (val) => {
                return moment(val).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        formatStatus: $vm => {
            return val => {
                if(val == '0'){
                    return $vm.$t('toBePaid')
                } else if(val == '100'){
                    return $vm.$t('tradeSuccess')
                }
            }
        },
        // 显示礼金支付相关内容
        showPoint() {
            if (this.uwLoading === 'loaded') {
                if (typeof this.pointSwitch !== "string") {
                    return this.pointSwitch.ruleSwitch&&this.pointSwitch.ruleSwitch.quantityDisplay?true:false
                }
            }
            return false;
        },
        //单位
        unit(){
            if(this.allGearData && this.allGearData.currencyList && this.allGearData.currencyList.length > 0&&this.currency){
                return this.allGearData.currencyList.filter(v => v.currency == this.currency)[0].currencyMark
            }
            return ''
        },
        // 当前页签下卡片数据
        currentTabGoods() {
            const cardList = this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].goodsInfo
            const groupedList = [];
            const rowSize = 4; // 一行4个
            // 遍历原始列表，每4个分为一组（一行）
            for (let i = 0; i < cardList.length; i += rowSize) {
                // 截取当前行的卡片（不足4个也会保留）
                const rowCards = cardList.slice(i, i + rowSize);
                groupedList.push({
                    rowId: `row-${i / rowSize}`, // 行唯一标识
                    list: rowCards // 当前行的卡片
                });
            }
            return groupedList ||[]
        },
        showCard(){
           return this.allGearData && this.allGearData.currencyList && this.allGearData.currencyList.length > 0
        }
    },
    mounted() {
        eventBus.$on('toPayByPassword', (pwd) => {
           this.payHandle(pwd)
        })
        this.appId=CONFIG.appId
        this.appConfig = CONFIG
        this.storage = JSON.parse(window.localStorage.getItem('storage'))
        this.buyList = (this.storage && this.storage.buyList) ? JSON.parse(this.storage.buyList) : []
        this.currency = window.localStorage.getItem('currency')
        this.isLogin = window.localStorage.getItem('isLogin') === 'true' ? true : false
        window.i18n.locale = window.localStorage.getItem('language')
        if(!window.localStorage.getItem('language')){
            this.$router.push({
              path: '/'
            })
        }
        this.getAllGear({
            appId: CONFIG.appId,
            language: window.localStorage.getItem('language'),
        })
        if(!this.isLogin){
            this.getWebUnLoadGoods({
                appId: CONFIG.appId,
                language: window.localStorage.getItem('language') !== 'undefined' ? window.localStorage.getItem('language') : 'en-US'
            })
        } else {
            this.serverIapList({
                accessToken: this.storage.accessToken,
                appId: CONFIG.appId,
                language: window.localStorage.getItem('language'),
            })
        }
        if(this.$route.query.buyList == '[]'){
            this.buyListShow = false
        }
        this.$watch('buyListShow', val => {
            console.log(val)
            if(this.goodsList.length > 0){
                if(val == true){
                    if(this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].goodsInfo.length > 4){
                        this.isScroll = true
                    } else {
                        this.isScroll = false
                    }
                } else {
                    if(this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].goodsInfo.length > 6){
                        this.isScroll = true
                    } else {
                        this.isScroll = false
                    }
                }
            }
        })
        this.$watch('orderLoading', val => {
            if(val === 'loaded'){
                this.orderInfo.list.map(val => {
                    this.orderList.push(val)
                })
                this.dialogShow = true
                this.totalPage = this.orderInfo.totalPage
                this.orderLoad = false
                this.loadShow = false
                this.loadStatus = false
                this.listLoading = false
            }
        })
        this.$watch('iapLoading', val => {
            if(val === 'loaded'){
                if(this.status == '-4'){
                this.logout()
                this.logoutAll()
                return false
                }
                this.iapInfo.map(v => {
                    if(v.goodsInfo.length > 0){
                        v.goodsInfo.map(goodsV => {
                            if(this.$route.query.buyList){
                                JSON.parse(this.$route.query.buyList).map(buyV => {
                                    if(goodsV.iapId == buyV.iapId && (this.buyList.filter(bv => bv.iapId == buyV.iapId).length == 0)){
                                        goodsV.amount = buyV.amount
                                        this.buyList.push(goodsV)
                                    }
                                })
                            } else {
                                if(this.buyList.length > 0){
                                    this.buyList.map(buyV => {
                                        if(goodsV.iapId == buyV.iapId && (this.buyList.filter(bv => bv.iapId == buyV.iapId).length == 0)){
                                            goodsV.amount = buyV.amount
                                            this.buyList.push(goodsV)
                                        }
                                    })
                                }
                            }
                        })
                    }
                })
                this.getPCGear({
                    accessToken: this.storage.accessToken,
                    targetCurrency: this.currency,
                    countryId: window.localStorage.getItem('countryId'),
                    appId: CONFIG.appId,
                })
                if(this.buyList.length == 0){
                    this.buyListShow = true
                } else {
                    this.buyListShow = false
                }
                this.storage.buyList = JSON.stringify(this.buyList)
                window.localStorage.setItem('storage', JSON.stringify(this.storage))
            }
        })
        this.$watch('wUnloadLoading', val => {
            if(val === 'loaded'){
                this.goodsList = this.wUnloadData.map(v => {
                    return v
                })
                this.goodsList = this.goodsList.filter(i => i.goodsInfo.length > 0)
                this.activeIdx = this.goodsList[0].typeKeyIdx + ''
                this.tabTypeName = this.goodsList[0].typeName
                this.totalCount = 0
                this.pointTotalCount = 0
                this.listCount = 0
                if(this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].goodsInfo.length > 4){
                    this.isScroll = true
                } else {
                    this.isScroll = false
                }
                this.contentShow = true
            }
        })
        this.$watch('pcgLoading', val => {
            if(val === 'loaded'){
                if(!this.buyDialogShow){
                    this.pcgJsonData = JSON.parse(JSON.stringify(this.pcgData))
                    this.goodsList = this.iapInfo.map(v => {
                        if(v.goodsInfo.length > 0){
                            v.goodsInfo = v.goodsInfo.filter(i => (i.endTs * 1000 > new Date().getTime() || i.endTs == 0))
                            v.goodsInfo = v.goodsInfo.filter(i => (i.goodsType == 0 || i.goodsType == 1))
                            // v.goodsInfo = v.goodsInfo.filter(i => (i.goodsInfo.length > 0))
                            if(this.buyList.length > 0){
                                v.goodsInfo = v.goodsInfo.map(goodsV => {
                                    goodsV.amount = (this.buyList.filter(buyV => buyV.iapId == goodsV.iapId).length > 0 && this.buyList.filter(buyV => buyV.iapId == goodsV.iapId)[0].amount) || 0
                                    return goodsV
                                })
                            }
                        }
                        return v
                    })
                    this.goodsList = this.goodsList.filter(i => i.goodsInfo.length > 0)
                    this.activeIdx = this.goodsList[0].typeKeyIdx + ''
                    this.tabTypeName = this.goodsList[0].typeName
                    if(this.buyList.length > 0){
                        this.payBtnShow = true
                    }
                    this.totalCount = 0
                    this.listCount = 0
                    this.pointTotalCount = 0
                    this.buyList.map(v => {
                        this.totalCount += Number(this.pcgJsonData[v.price] * 100) * v.amount
                        this.pointTotalCount += Number(v.scaledPoints* 100) * v.amount
                        this.listCount += v.amount
                    })
                    if(this.goodsList.filter(i => i.typeKeyIdx == this.activeIdx)[0].goodsInfo.length > 4){
                        this.isScroll = true
                    } else {
                        this.isScroll = false
                    }
                    this.contentShow = true
                    this.storage.buyList = JSON.stringify(this.buyList)
                    window.localStorage.setItem('storage', JSON.stringify(this.storage))
                }
            }
        })
        this.$watch('orderStatus', val => {
            if(val == 'stated'){
                if(this.status == 10021){
                    this.$confirm(this.$t('sureGoodsAgain'), this.$t('sureAgain'), {
                        cancelButtonText: this.$t('cancel'),
                        confirmButtonText: this.$t('sure'),
                        center: true
                    })
                    .then(() => {
                        this.serverIapList({
                            accessToken: this.storage.accessToken,
                            appId: CONFIG.appId,
                            language: window.localStorage.getItem('language')
                        })
                        let ids = this.orderData.map(v => {
                            return v.iapId
                        })
                        this.buyList = this.buyList.filter(v => !ids.includes(v.iapId))
                        this.totalCount = 0
                        this.pointTotalCount = 0
                        this.listCount = 0
                        this.buyList.map(v => {
                            if(this.mustInteger){
                                this.totalCount += Number(Math.ceil(this.pcgJsonData[v.price]) * 100) * v.amount
                                this.pointTotalCount += Number(v.scaledPoints* 100) * v.amount
                                this.listCount += v.amount
                            } else {
                                this.totalCount += Number(this.pcgJsonData[v.price] * 100) * v.amount
                                this.pointTotalCount += Number(v.scaledPoints* 100) * v.amount
                                this.listCount += v.amount
                            }
                        })
                        window.localStorage.setItem('buyList', JSON.stringify(this.buyList))
                        setTimeout(() => {
                            this.$router.go(0)
                        }, 500)
                    })
                    .catch(() => {
                    });
                } else if(this.status == 10023) {
                    this.getPCPayM({
                        appId: CONFIG.appId,
                        language: window.localStorage.getItem('language'),
                        accessToken: this.storage.accessToken,
                        countryId: window.localStorage.getItem('countryId'),
                        currency: this.currency,
                        goodsLists: this.buyList,
                        totalMoney: ((this.totalCount/100).toFixed(2))
                    })
                }
                else if (this.status == 10024) {
                    if (this.orderData < 5) {
                        this.$confirm(  
                            this.$t("pwdErrorTimes",{
                                msg: 5 - this.orderData,
                            }),
                            this.$t("errorMsg"),
                            {
                            cancelButtonText: this.$t('cancel'),
                            confirmButtonText: this.$t('sure'),
                            center: true
                            }
                            
                        );
           
                    } else {
                        this.$confirm(this.$t("pwdErrorMax"),
                            this.$t("errorMsg"),
                            {
                            cancelButtonText: this.$t('cancel'),
                            confirmButtonText: this.$t('sure'),
                            center: true
                            }  
                        );
                    }
                }
                else {
                    if(this.payment.payChannel == 'gash' || this.payment.payChannel == 'p99'){
                        this.payLoadShow = true
                        const tempForm = document.createElement("form")
                        tempForm.action = this.orderData.extInfo.redirectUrl
                        tempForm.target = '_self'
                        tempForm.method = 'post'
                        tempForm.style.display = 'none'
                        let opt = document.createElement("input")
                        opt.name = 'data'
                        opt.value = this.orderData.extInfo.data
                        tempForm.appendChild(opt)
                        document.body.appendChild(tempForm)
                        tempForm.submit()
                    } else {
                        window.location.href = this.orderData.extInfo.redirectUrl
                    }
                }
            }
        })
    },
    beforeDestroy() {
        eventBus.$off('toPayByPassword'); // 必须取消订阅
    },
}
</script>
 
<style lang="scss">
.scroller-container {
  height: 100%;
  width: 100%;
  padding: 0 25px; /* 抵消Grid左右间距的一半，布局居中 */
}
.vue-recycle-scroller::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
/* 2. 每行的Grid容器：一行4个，间距50px */
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 强制一行4列 */
  gap: 30px 14px; /* 行列间距50px */
  width: 100%;
  padding-top: 10px;
  margin-bottom: 0; /* 避免额外间距影响item-size */
}

.store{
    position: relative;
    width: 100%;
    height: 100%;
    color: #fff5d4;

    .el-card{
        width: 1200px;
        margin: 0 auto;
    }
    .el-tabs__content{
        height: calc(100vh - 278px);
        overflow-y: scroll;
        &.otherTab{
            height: calc(100vh - 226px);
        }
        &::-webkit-scrollbar{
            width: 0 !important;
            height: 0 !important;
            display: none;
        }
    }
    .el-tabs__nav-wrap::after{
        height: 0;
    }
    .el-tabs__item{
        height: 28px;
        line-height: 28px;
        border: 1px solid #e0e0e0;
        margin: 0 5px;
        background-color: #f2f2f2;
        border-radius: 20px;
        padding: 0 10px;
        &.is-active{
            color: #fff;
            background-color: #d32e26;
            border-color: #d32e26;
            &:hover{
                color: #fff;
            }
        }
        &:hover{
            color: inherit;
        }
        p{
            margin: 0;
        }
    }
    .el-tabs__active-bar{
        height: 0;
    }
    .el-tabs__nav-next, .el-tabs__nav-prev{
        line-height: 30px;
    }
    .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--top .el-tabs__item.is-top:nth-child(2){
        padding-left: 10px;
    }
    .el-tabs--bottom .el-tabs__item.is-bottom:last-child, .el-tabs--bottom .el-tabs__item.is-top:last-child, .el-tabs--top .el-tabs__item.is-bottom:last-child, .el-tabs--top .el-tabs__item.is-top:last-child{
        padding-right: 10px;
    }
    .coll_status{
        display: inline-block;
        right: 90px;
        position: absolute;
        font-size: 20px;
    }
    .el-input::-webkit-scrollbar-thumb{
        border-radius: 0;
    }
    .el-input__inner{
        border-radius: 0;
    }
    .pop_down_pop{
        z-index: 1;
        background-color: rgba(0,0,0,0);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    .close{
        // background: url('../assets/close.png') 0 100% no-repeat;
        background-size: 100% auto !important;
        width: 47px;
        height: 47px;
        position: absolute;
        cursor: pointer;
        left: 330px;
        top: 28px;
    }
    .el-input.is-disabled .el-input__inner{
        background-color: transparent;
        color: #000;
        padding: 0;
    }
    .el-badge__content{
        background-color: #d32e26;
        // top: 40px;
        // right: 64px;
    }
    .item_count{
        left: 240px;
        top: 145px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .shop-cart-content{
            margin-right: 10px;
            display: flex;
            align-items: center;
            .el-input-number{
                width: 100px;
                border-radius: 4px;
                overflow: hidden;
                background-color: transparent;
                input{
                    padding: 0;
                    margin: 0;  
                    border-radius: 4px;
                }
                .el-input-number__decrease,.el-input-number__increase{
                    background-color: #d32e26;
                    color: #fff; 
                }
            }
            .disable-btn{
                .el-input-number__increase{
                    background-color: #fab6b6;
                    filter: grayscale(100%);
                    cursor: no-drop;
                }
            }
        }
       
       
        .plus,  .cost{
          
            background-size: 18px 20px !important;
            display: inline-block;
            width: 18px;
            height: 18px;
            border-radius: 9px;
            cursor: pointer;
            line-height: 18px;
            background-color: #d32e26;
            color: #fff;
            margin-top: 4px;
            text-align: center;
            &.plus_disable{
                background-color: #d32e26;
                filter: grayscale(100%);
                cursor: no-drop;
            }
        }
    }
    .top{
        height: 90px;
        position: relative;
        display: flex;
        .top_left{
            position: relative;
            width: 300px;
            height: 90px;
            .icon{
                position: absolute;
                width: 57px;
                height: 57px;
                top: 20px;
                left: 30px;
            }
            .game_name{
                font-size: 20px;
                position: absolute;
                left: 90px;
                top: 20px;
            }
            .game_name_line{
                font-size: 28px;
                position: absolute;
                left: 90px;
                top: 45px;
            }
        }
        .top_center{
            position: relative;
            width: 872px;
            height: 90px;
            text-align: left;
            .uname{
                position: relative;
                font-size: 38px;
                line-height: 90px;
                display: inline-block;
            }
            .server_name{
                position: relative;
                font-size: 38px;
                display: inline-block;
                line-height: 90px;
            }
        }
        .top_right{
            position: relative;
            width: 300px;
            height: 90px;
            text-align: left;
            .point_num{
                line-height: 90px;
                font-size: 28px;
                em{
                    font-size: 24px;
                    font-style: initial;
                }
            }
            .detail{
                // background: url('../assets/detail.png') 0 100% no-repeat;
                background-size: 29px 29px !important;
                width: 29px;
                height: 29px;
                position: relative;
                display: inline-block;
                top: 4px;
                left: 4px;
                cursor: pointer;
            }
            .user{
                // background: url('../assets/user.png') 0 100% no-repeat;
                background-size: 47px 47px !important;
                width: 47px;
                height: 47px;
                position: absolute;
                cursor: pointer;
                left: 260px;
                top: 28px;
            }
            .pop_down{
                // background: url('../assets/pop_down.png') 0 100% no-repeat;
                background-size: 288px 339px !important;
                width: 288px;
                height: 339px;
                position: relative;
                left: 115px;
                top: 60px;
                z-index: 9;
                .down_li{
                    position: relative;
                    margin: 0 30px;
                    top: 32px;
                    line-height: 46px;
                    border-bottom: 1px solid #473420;
                    // background: url('../assets/arrow_right.png') 100% 50% no-repeat;
                    background-size: 11px 21px !important;
                    cursor: pointer;
                    &:last-child{
                        border-bottom: 0px solid #473420;
                    }
                }
            }
        }
    }
    .el-dialog__body{
        padding: 0 20px;
    }
    
    .content_right{
        .el-dialog__headerbtn{
            top: 10px;
            right: 10px;
            background-color: #f7f7f7;
            border-radius: 10px;
        }
        // background: url('../assets/buylist.png') 0 100% no-repeat;
        // width:400px;
        .el-dialog{
            height: calc(100vh - 230px);  
            border-radius: 20px;
        }
        .right_close{
            width: 24px;
            height: 67px;
            position: absolute;
            left: 1177px;
            top: 354px;
            cursor: pointer;
        }
        .clear{
            position: relative;
            right: 0;
            text-align: right;
            height: 40px;
            line-height: 40px;
            padding-right: 40px;
            cursor: pointer;
        }
        .left_detial{
            width: 48%;
            height: 14px;
            line-height: 14px;
            height: 70px;
            background-color: #f7f7f7;
            border: 1px solid #dedede;
            border-radius: 5px;
        }
        .buy_list_box{
            width: 48%;
            height: calc(100vh - 450px);
            margin: 20px 0;
            overflow-y: scroll;
            background-color: #f7f7f7;
            border: 1px solid #dedede;
            border-radius: 5px;
            &::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
        }
        .submit_box{
            height: 50px;
            background-color: #f7f7f7;
            border: 1px solid #dedede;
            border-radius: 5px;
            .total_count{
                margin-top: 0;
                line-height: 50px;
                text-align: left;
                text-indent: 20px;
                color: #d32e26;
                font-weight: bolder;
            }
        }
        .pay_box{
            position: absolute;
            top: 0;
            right: 0;
            width: 48%;
            height: calc(100vh - 357px);
            margin: 0;
            margin-right: 15px;
            overflow-y: scroll;
            background-color: #f7f7f7;
            border: 1px solid #dedede;
            border-radius: 5px;
            &::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
            .channel_title{
                color: #3f3f3f;
                font-size: 14px;
                text-align: left;
                margin-top: 10px;
                margin-left: 10px;
            }
            .title{
                font-size: 36px;
                line-height: 36px;
                color: #f0d386;
                font-weight: bolder;
            }
            .pay_total{
                display: flex;
                justify-content: space-between;
                font-size: 28px;
                margin-top: 20px;
                color: #f0d386;
            }
            .pay_line{
                height: 1px;
                border-top: 1px solid #685c3d;
                width: 300px;
                margin-top: 20px;
            }
            .channel_box{
                display: flex;
                justify-content: left;
                flex-wrap: wrap;
                align-content: baseline;
                margin-top: 10px;
                overflow-y: scroll;
                &::-webkit-scrollbar{
                    width: 0 !important;
                    height: 0 !important;
                    display: none;
                }
                .channel{
                    // background: url('../assets/pay.png') 0 100% no-repeat;
                    width: 100%;
                    height: 48px;
                    display: block;
                    line-height: 24px;
                    color: #000;
                    font-size: 14px;
                    font-weight: bolder;
                    cursor: pointer;
                    margin: 10px 14px 0;
                    border: 1px solid #dedede;
                    border-radius: 8px;
                    &:hover{
                        // background: url('../assets/pay_hover.png') 0 100% no-repeat;
                        // border: 1px solid #d32e26;
                        // color: #d32e26;
                    }
                    &.channel_hover{
                        // background: url('../assets/pay_hover.png') 0 100% no-repeat;
                        border: 1px solid #d32e26;
                        color: #d32e26;
                    }
                    &.channel_disable{
                        cursor: no-drop;
                        // background: url('../assets/pay_disable.png') 0 100% no-repeat;
                        color: #dedede;
                    }
                }
            }
        }
        .buy_list{
            position: relative;
            // border-bottom: 2px solid #473420;
            margin-left: 10px;
            height: 115px;
            margin-top: 10px;
            .list_icon{
                background-size: 100% auto !important;
                background-repeat: no-repeat;
                background-position: 50% 50%;
                width: 100px;
                height: 100px;
                margin: 0 auto;
                position: absolute;
                top: 10px;
                left: 20px;
            }
            .list_name{
                font-size: 14px;
                text-align: left;
                text-indent: 140px;
                font-weight: bolder;
                line-height: 14px;
                top: 0;
                width: calc(100% - 10px);
                position: relative;
            }
            .list_limit{
                display: inline-block;
                width: 100%;
                width: calc(100% - 120px);
                padding-left: 120px;
                span{
                    color: #949494;
                    font-size: 12px;
                    position: relative;
                    // display: inline-block;
                    text-align: left;
                    background-color: transparent;
                    border: 1px solid #949494;
                    border-radius: 4px;
                    padding: 2px 10px;
                    margin-left: 10px;
                    margin-top: 5px;
                    top: 0;
                    float: left;
                }
            }
            .list_point{
                font-size: 14px;
                position: relative;
                top: 0;
                text-align: left;
                line-height: 14px;
                color: #d32e26;
                font-weight: bolder;
            }
            .item_count{
                width: calc(100% - 140px);
                position: relative;
                top: 0;
                left: 140px;
                text-align: left;
            }
        }

        .total_count{
            font-size: 24px;
            line-height: 36px;
            margin-top: 20px;
        }
        .submit{
            // background: url('../assets/submit.png') 0 0 no-repeat;
            // width: 190px;
            // height: 44px;
            // font-size: 26px;
            // line-height: 44px;
            // color: #5d371a;
            position: absolute;
            right: 30px;
            margin-top: 5px;
            cursor: pointer;
            color: #fff;
            background-color: #d32e26;
            border-radius: 30px;
            &.is-disabled{
                background-color: #fab6b6;
                border-color: #fab6b6;
                cursor: not-allowed;
            }
        }
        // background-color: #fff;
    }
    .content{
        position: relative;
        height: calc(100vh - 160px);
        display: flex;
        flex-direction: column;
        .typename{
            font-size: 30px;
            position: absolute;
            left: 300px;
            margin-top: -46px;
        }
        
        .content_left{
            width: 300px;
            cursor: pointer;
            margin-top: 5px;
            margin-bottom: 15px;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
            .tab{
                font-size: 33px;
                line-height: 73px;
                text-align: center;
                font-weight: bolder;
                text-shadow: 1px 1px black;
                // background: url('../assets/tab.png') 85% 50% no-repeat;
                background-size: 20px 20px;
                p{
                    margin: 0;
                    width: 70%;
                    margin-left: 15%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                &.tab_hover{
                    font-size: 30px;
                    line-height: 73px;
                    text-align: center;
                    font-weight: bolder;
                    text-shadow: 1px 1px black;
                    // background: url('../assets/tab_hover.png') 0 100% no-repeat;
                    background-size: 310px 73px;
                }
            }
        }
        .content_center{
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            align-content: baseline;
            overflow-y: scroll;
            margin-bottom: 3px;
            padding-top:20px;
            height: 656px;
            &::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
            &.scroll_bar_none::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
            .card{
                position: relative;
                width: 260px;
                height: 300px;
                // background: url('../assets/card.png') 89% 50% no-repeat;
                overflow: visible;
                // margin: 30px 14px;
                .item_content{
                    display: none;
                }
                .item_limit{
                    display: block;
                }
            }
            // .card:hover{
            //     top: -15px;
            //     width: 415px;
            //     height: 288px;
            //     background: url('../assets/card_hover.png') 89% 50% no-repeat;
            //     .item_content{
            //         display: block;
            //     }
            //     .item_limit{
            //         display: none;
            //     }
            // }
            .item_icon{
                background-size: 100% auto !important;
                background-repeat: no-repeat;
                background-position: 50% 50%;
                width: 153px;
                height: 153px;
                margin: 0 auto;
            }
            .item_name{
                font-size: 20px;
                line-height: 20px;
                margin-top: 4px;
                text-align: center;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                &.min_font{
                    font-size: 18px;
                }
            }
            .item_point{
                position: absolute;
                left: 21px;
                bottom: 16px;
                font-size: 18px;
                text-align: center;
                width: 220px;
                border-radius: 20px;
                background-color: #d32e26;
                border-color: #d32e26;
                &.is-disabled{
                    background-color: #fab6b6;
                    border-color: #fab6b6;
                }
            }
            .item_limit{
                color: #fff;
                font-size: 14px;
                background-color:#d32e26;
                padding: 2px 10px;
                float: center;
                position: absolute;
                right: -5px;
                top: -5px;
                border-top-right-radius: 10px;
                border-top-left-radius: 10px;
                border-bottom-right-radius: 10px;
            }
            .item_limit_time{
                background-color: #fff;
                color: #9e9e9e;
                border: 1px solid #e6e6e6;
                font-size: 12px;
                border-radius: 4px;
                display: inline-block;
                padding: 0 5px;
                margin-bottom: 5px;
                &.none{
                    border: 0;
                }
            }
            .item_content{
                color:#584227;
                font-size: 20px;
                line-height: 25px;
                text-align: center;
                position: absolute;
                top: 205px;
                padding: 0 40px;
                height: 75px;
                overflow-y: scroll;
                &::-webkit-scrollbar{
                    width: 0 !important;
                    height: 0 !important;
                    display: none;
                }
            }
        }
        .full_center{
            width: 1272px;
        }
        .buy_car{
            // background: url('../assets/buy_car.png') 0 0 no-repeat;
            width: 50px;
            height: 50px;
            font-size: 36px;
            line-height: 50px;
            position: absolute;
            right: 20px;
            bottom: 50px;
            color: #d32e26;
            border-radius: 25px;
            border: 1px solid #d32e26;
            background-color: #fff;
            cursor: pointer;
            div{
                width: 100%;
                height: 100%;
            }
            i{
                line-height: 50px;
            }
        }
    }
    .point_cart{
        position: absolute;
        left: 9px;
        font-size: 36px;
        color: #d32e26;
        top: 0;
        display: none;
    }
    .cartSlideOut{
        display: block;
        animation: cartAnimate 300ms linear 1;
    }
    @keyframes cartAnimate {
        0%{
            transform: translate3D(-100px, -100px, 0);
            opacity: 1;
        }
        20%{
            transform: translate3d(-70px, -160px, 0);
            opacity: 1;
        }
        100%{
            transform: translate3D(0, 0, 0);
            opacity: 1;
        }
    }
    // @keyframes cartAnimate {
    //     0%{
    //         transform: translate3D(0, -200px, 0);
    //         opacity: 1;
    //     }
    //     20%{
    //         transform: translate3d(0, -160px, 0);
    //         opacity: 1;
    //     }
    //     100%{
    //         transform: translate3D(0, 0, 0);
    //         opacity: 1;
    //     }
    // }
}
.point-pay-dialog{
     .el-message-box__btns .el-button{
        font-size: 16px;
    }
}
</style>